/*
 * Copyright (C) 2018 Spanning Cloud Apps LLC.  All rights reserved.
 */

/*
 * This module provides access to the alert rule management functions of the server.
 */
angular
  .module('services.alertRules', ['http.alertRules'])
  .factory('AlertRuleService', ['$rootScope', 'httpAlertRules', factory]);

/**
 * The factory that creates the service.
 */
function factory($rootScope, httpAlertRules) {
  // Expose the functions only, not the data
  return {
    addRule,
    deleteRule,
    getRules,
    updateRule
  };

  /**
   * Adds a new alert rule.
   *
   * @param {object} props - the settings of the rule to be created.
   * @returns {Promise<object>} the promise of the new alert rule.
   */
  function addRule(props) {
    $rootScope.showLoadingMask = true;
    return httpAlertRules.addRule(props).finally(() => {
      $rootScope.showLoadingMask = false;
    });
  }

  /**
   * Deletes an alert rule.
   *
   * @param {number} id - the Spanning id of the rule to be deleted.
   * @returns {Promise<void>} the promise of the completion of the action.
   */
  function deleteRule(id) {
    $rootScope.showLoadingMask = true;
    return httpAlertRules.deleteRule(id).finally(() => {
      $rootScope.showLoadingMask = false;
    });
  }

  /**
   * Returns the alert rules for the current org.
   *
   * @returns {Promise<object[]>} the promise of the list of alert rules.
   */
  function getRules() {
    $rootScope.showLoadingMask = true;
    return httpAlertRules.getRules().finally(() => {
      $rootScope.showLoadingMask = false;
    });
  }

  /**
   * Updates an alert rule.
   *
   * @param {number} id - the Spanning id of the rule to be updated.
   * @param {object} props - the settings of the rule to be updated.
   * @returns {Promise<object>} the promise of the updated alert rule.
   */
  function updateRule(id, props) {
    $rootScope.showLoadingMask = true;
    return httpAlertRules.updateRule(id, props).finally(() => {
      $rootScope.showLoadingMask = false;
    });
  }
}
